import { Injectable } from "@angular/core";
import { SdkBase } from "@utilities/sdk-base/sdk.base";
import { Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class WorkflowSdk extends SdkBase {
	public cancelWorkflow(workflowName: string, workflowKey: string): Observable<void> {
		return this.makeHttpRequest('post', 'api2/workflow/cancel', {workflowName, workflowKey})
	}
}
